import { render, staticRenderFns } from "./Angpao.vue?vue&type=template&id=ffaf6848&scoped=true&"
import script from "./Angpao.vue?vue&type=script&lang=js&"
export * from "./Angpao.vue?vue&type=script&lang=js&"
import style0 from "./Angpao.vue?vue&type=style&index=0&id=ffaf6848&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ffaf6848",
  null
  
)

export default component.exports